module.exports = __webpack_public_path__ + "static/share-social-da004231a2061f196c08c9fc8c6ba7ad.jpg";